<div class="modal-header">
    <h3 class="modal-title">Paperless Settings for {{user.EmployeeName}}</h3>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-md-12">
            <table class="table">
                <thead>
                    <tr>
                        <th>Document</th>
                        <th>Consented</th>
                        <th>Date Modified</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngIf="settings.showPay">
                        <td>Paystub</td>
                        <td><input type="checkbox" style="width: 25px; height: 25px; vertical-align: middle;" [(ngModel)]="user.ConsentPaystubs" [disabled]="updatingSettings" (change)="updateSettings()"></td>
                        <td>{{consentPaystubsModifiedDisplay}}</td>
                    </tr>
                    <tr *ngIf="settings.showW2">
                        <td>W2/T4</td>
                        <td><input type="checkbox" style="width: 25px; height: 25px; vertical-align: middle;" [(ngModel)]="user.ConsentW2T4" [disabled]="updatingSettings" (change)="updateSettings()"></td>
                        <td>{{consentW2ModifiedDisplay}}</td>
                    </tr>
                    <tr *ngIf="settings.show1095">
                        <td>1095-C</td>
                        <td><input type="checkbox" style="width: 25px; height: 25px; vertical-align: middle;" [(ngModel)]="user.ConsentACA1095" [disabled]="updatingSettings" (change)="updateSettings()"></td>
                        <td>{{consentC1095ModifiedDisplay}}</td>
                    </tr>
                    <tr>
                        <td>Opt out of non-emergency SMS?</td>
                        <td><input type="checkbox" style="width: 25px; height: 25px; vertical-align: middle;" [(ngModel)]="user.OptOutSMS" [disabled]="updatingSettings"  (change)="updateSettings()"></td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="closeModal()">Close</button>
</div>